import { AppConfigCodec } from './app_config';
import { ConfigBuilderGeneric } from './config_builder_generic';
import { ConfigContext } from './config_builder_generic';
export const ConfigBuilder = (props) => ConfigBuilderGeneric(Object.assign(Object.assign({}, props), { codec: AppConfigCodec, context: ConfigContext }));
